import type { RootState } from './store';

export const selectSurveyLanguage = (state: RootState) => state.app.surveyLanguage;
export const selectSurveyScreening = (state: RootState) => state.app.surveyScreening;
export const selectPdpaConsent = (state: RootState) => state.app.pdpaConsent;
export const selectOtpDraft = (state: RootState) => state.app.otpDraft;
export const selectStaffRef = (state: RootState) => state.app.staffRef;
